import { Component, OnInit,Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';

export interface DialogData { 
  datos:any;
}
@Component({
  selector: 'app-ver-constancia',
  templateUrl: './ver-constancia.component.html',
  styleUrls: ['./ver-constancia.component.scss']
})
export class VerConstanciaComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public dialogRef: MatDialogRef<VerConstanciaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit() {    
    
    document.querySelector(".constanciaImg").setAttribute( "src", "assets/uploads/constancias/"+this.data.datos.constancia )
  }

}
